import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import KakobuyArticle from "@/pages/kakobuy/page";
import CSSBuyArticle from "@/pages/cssbuy/page";
import SuperbuyArticle from "@/pages/superbuy/page";
import OopbuyArticle from "@/pages/oopbuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-hipobuy-sheet",
    element: <ArticlePage />,
  },
  {
    path: "/kakobuy-spreadsheet",
    element: <KakobuyArticle />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CSSBuyArticle />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuyArticle />,
  },
  {
    path: "/oopbuy-spreadsheet",
    element: <OopbuyArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;